module.exports = __webpack_public_path__ + "img/4.0216ca4b.svg";